export default __webpack_public_path__ + "static/media/screenshot1.05104ef7.jpg";